import {EventConstants} from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';
import AaSequenceActions from 'molbio/aa-sequences/AaSequenceActions';
import {AaSequenceServerResponse} from 'molbio/aa-sequences/util/AaSequenceConstants';
import notifications, {Response, ResponseJSON} from 'notifications';

type AaSequenceUpdateErrorResponse = Response & {
  responseJSON?: ResponseJSON & {updatedProtein?: AaSequenceServerResponse};
};

/**
 * Error handler for any AA sequence DAO operations
 */
const handleAaSequenceUpdateError = (e: AaSequenceUpdateErrorResponse): void => {
  // If the AA sequence was out of date, we'll get an error with the new AA sequence.
  const aaSequence = e.responseJSON && e.responseJSON.updatedProtein;
  if (aaSequence) {
    AppDispatcher.dispatch({
      actionType: EventConstants.AA_SEQUENCE_UPDATE_COMPLETED,
      proteinId: aaSequence.id,
      newAaSequence: aaSequence,
    });
    AaSequenceActions.fetchVersions(aaSequence.id);
  }
  notifications.notifyError(e);
};

export default handleAaSequenceUpdateError;
